import Endpoint from './endpoint'
import { API_URL } from './index'

export default class Contacts extends Endpoint {
  async all() {
    let url = new URL(`/api/contacts`, API_URL)
    return this.request(url)
  }

  async one(id) {
    let url = new URL(`/api/contacts/${id}`, API_URL)
    return this.request(url)
  }

  async search(query) {
    let url = new URL(`/api/contacts`, API_URL)
    url.searchParams.set('query', query)
    return this.request(url, {}, false)
  }
}
